module.exports = __webpack_public_path__ + "img/13.f150f01f.png";